import { Card } from 'antd'
import React, { useState } from 'react'
import ActionsLogItem from './Components/ActionsLogItem'

function ActionsLog({data}) {

  const [height, setHeight] = useState(0);
  var int = 0;
  var total = 0;

  const handleHeight = (e) => {
    if(int<3){
      total += e
      int++
      if(int === 3){
        setHeight(total)
      }
    }
    
  }

  return (
    <Card title="Actions Log" bordered={false}>

      <div style={{ border: '1px solid var(--border-color)', overflow:"scroll", maxHeight:height, overflowX:"hidden" }} >

        {data?.map((obj)=>
            <ActionsLogItem getHeight={handleHeight} data={obj} />
        )}
        
      </div>

    </Card>
  )
}

export default ActionsLog